// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d09674fc","455":"cef29544","810":"c81d74e7","977":"354553e3"}[chunkId] + ".chunk.js";
};